export default __webpack_public_path__ + "static/media/bg2.756b2348.png";